import gql from 'graphql-tag';

import { ClaimViewFields } from './fragments/claim';

export const GetClaim = gql`
  query GetClaim($claimId: String!) {
    getClaim(claimId: $claimId) {
      result
      errorCode
      reasons
      claim {
        ...ClaimViewFields
      }
    }
  }
  ${ClaimViewFields}
`;
